export enum EnrichmentType {
  PRIVATE_EMAIL = "privateEmail",
  BUSINESS_EMAIL = "businessEmail",
  PHONE = "phone",
}
